import { store } from "app/store";

/**
 * Checks if the current user has access to the current tenant
 * @returns {boolean} true if the user has access to the current tenant, false otherwise
 */
export const hasAccessToCurrentTenant = (): boolean => {
  // Get current state from Redux
  const state = store.getState();

  // Get current store code and admin stores
  const currentStoreCode = state?.store?.code;
  const adminData = state?.adminData;
  const currentAdminStores = adminData?.roles?.[0]?.stores || [];

  // Check if admin has access to the current store
  return (
    currentStoreCode !== undefined &&
    currentStoreCode !== "" &&
    currentAdminStores.includes(currentStoreCode)
  );
};
